module.exports = __webpack_public_path__ + "images/emoji/bust_in_silhouette.f27615cc0db5c22d6484.png";